module.exports = __webpack_public_path__ + "static/img/son7_active.600aa69a.png";